import printStatementTemplate from './PrintStatement.template.html';

/*******************************************************************************
 * Service: PrintStatementDialogService */
/**
 * @ngdoc  service
 * @module bankReconHistory
 * @name   bankReconHistory.service:PrintStatementDialogService
 * @description
 * Utility to show a dialog to print statement.
 *******************************************************************************/
/* @ngInject */ export function PrintStatementDialogService($uibModal) {
  /*****************************************************************************
   * Properties
   *****************************************************************************/
  /** Self reference. */ var mThis = this;

  /*****************************************************************************
   * show */
  /**
   * @ngdoc     method
   * @module    bankReconHistory
   * @methodOf  bankReconHistory.service:PrintStatementDialog
   * @param     {long}  statementID  Bank Statement to print.
   * @description
   * Show the modal dialog for printing the statement.
   *****************************************************************************/
  mThis.show = function (statementID) {
    return $uibModal.open({
      animation: true,
      backdrop: 'static',
      controller: PrintStatementDialogController,
      resolve: {
        statementID: function () {
          return statementID;
        }
      },
      size: 'sm',
      template: printStatementTemplate
    }).result;
  };
}

/*******************************************************************************
 * Controller: PrintStatementDialogController */
/**
 * @ngdoc   controller
 * @module  bankReconHistory
 * @name    bankReconHistory.controller:PrintStatementDialogController
 * @description
 * Handles the button events from the print dialog.
 *******************************************************************************/
/* @ngInject */ function PrintStatementDialogController($scope, statementID, Session) {
  /*****************************************************************************
   * Properties
   *****************************************************************************/
  $scope.print = {
    statementID: statementID,
    detail: false,
    format: 'PDF'
  };

  /*****************************************************************************
   * generate */
  /**
   * Generates the statement based on the selected options.
   *****************************************************************************/
  $scope.generate = function () {
    var pageURL = Session.getSessionURL(
      '/BankReconReport.aspx' +
        '?sid=' +
        $scope.print.statementID +
        '&ind=' +
        $scope.print.detail +
        '&rt=' +
        $scope.print.format
    );

    window.open(pageURL);
  };
}
